import { useState, useEffect } from "react";
import { projectFirestore, timestamp } from "../../firebase-config/config";
import { useLocation } from "react-router-dom";
import { useAuthContext } from "../../firebase-files/hooks/useAuthContext";
import { useDocument } from "../../firebase-files/hooks/useDocument";
import { useFirestore } from "../../firebase-files/hooks/useFirestore";
import "./ContactUs.css";
import CorporateTwoClients from "../../templates/corporate/corporateTwo/corporateTwoComponents/CorporateTwoClients/CorporateTwoClients";
import { useSignupPhone } from "../../firebase-files/hooks/useSignupPhone";
import { useNavigate } from "react-router-dom";
import { projectStorage } from "../../firebase-config/config";
import PhoneInput from "react-phone-input-2";
import { Alert } from "react-bootstrap";
import OtpInput from "react-otp-input";
import { useRef } from "react";
import PGLoaders from "../PGLoaders/PGLoaders";
import { MDBCardText } from "mdb-react-ui-kit";
import { useSendEmail } from "../../firebase-files/hooks/useSendEmail";
// Simple email validation regex
const validateEmail = (email) => {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(String(email).toLowerCase());
};

const ContactUs = () => {
  const { sendMyEmail } = useSendEmail();

  const location = useLocation();
  const { user } = useAuthContext();
  const { document: contactDetails } = useDocument("settings", "contactUs");
  const { document: contactPageData } = useDocument("pages-data", "contactUs");
  const { document: siteColors } = useDocument("settings", "Colors");
  const { document } = useDocument("settings", "organisation");
  const { addDocument, response } = useFirestore("enquiries");

  const { document: dbEmailDoc } = useDocument(
    "email_templates",
    "contact_us_temp"
  );

  const { updateDocument: updateContactUsDocument } =
    useFirestore("pages-data");

  const { document: qrCodeData } = useDocument("pages-data", "paymentDetails");
  const { updateDocument: updateQrCodeDocument } = useFirestore("pages-data");

  // START LOGIN USING CONTACT FORM
  const [isQrPopupOpen, setIsQrPopupOpen] = useState(false);
  const [isQrUploading, setIsQrUploading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false); // State for snackbar
  const [snackbarMessage, setSnackbarMessage] = useState(""); // State for snackbar message
  // const [uploadError, setUploadError] = useState(null); // State for upload error message
  const [isEditingUpiId, setIsEditingUpiId] = useState(false);
  const [upiId, setUpiId] = useState(qrCodeData && qrCodeData.upiId); // Initial state with qrCodeData if available
  const [isUser, setUser] = useState();
  const [activeTab, setActiveTab] = useState(1);
  const [otp, setOtp] = useState("");
  const [phone, setPhone] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [city, setCity] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [country, setCountryName] = useState("");
  const [address, setAddress] = useState("");
  const [isResendDisabled, setIsResendDisabled] = useState(false);
  const { setUpRecapcha, resendOTP } = useSignupPhone();
  const [confirmObj, setConfirmObj] = useState("");
  const [userName, setUserName] = useState("");
  const [mobilenoSliderState, setmobilenoSliderState] = useState(true);
  const [otpSliderState, setotpSliderState] = useState(false);
  const [newUserSliderState, setnewUserSliderState] = useState(false);
  const [genderSelectionSliderState, setGenderSelectionSliderState] =
    useState(true);
  const [newUserDetailsSliderState, setNewUserDetailsSliderState] =
    useState(false);
  const navigate = useNavigate();
  const [resendOTPFlag, setResendOTPFlag] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isOtpVisible, setIsOtpVisible] = useState(false);
  const [addresses, setAddresses] = useState("");
  const [isAttendance, setIsAttendance] = useState("");
  const [vehicleNumberPlate, setVehicleNumberPlate] = useState("");
  const [vehicleStatus, setVehicleStatus] = useState("");
  const [vehicleType, setVehicleType] = useState("");
  const [drivingLicence, setDrivingLicence] = useState("");
  const [faceRegistration, setFaceRegistration] = useState("");
  const { updateDocument, response: responseUpdateDocument } =
    useFirestore("users");

  // const { documents: allCategories, error: allCategoriesError } =
  //   useCollection("m_categories");

  const handleWheel = (e) => {
    // Prevent scrolling changes
    e.preventDefault();
  };

  //   send opt
  const getOTP = async (e) => {
    e.preventDefault();
    setIsResendDisabled(true);
    setError("");

    // Check if name, email, and message are required
    if (!name) {
      return setError("Full Name is required.");
    }
    // Check if email is required
    if (!email) {
      return setError("Email is required.");
    }

    // Validate email structure
    if (!validateEmail(email)) {
      return setError("Please enter a valid email address.");
    }

    // Check if message is required
    if (!formData.message) {
      return setError("Message is required.");
    }

    // Validate phone number
    if (phone === "" || phone === undefined || phone.length < 10) {
      return setError("Please enter a valid mobile number");
    }

    try {
      setIsLoading(true);
      // let btnSendOTP = document.getElementById("btn_sendotp");
      // btnSendOTP.style.display = "none";
      const respons = await setUpRecapcha("+" + phone);
      setConfirmObj(respons);
      setmobilenoSliderState(false);
      setotpSliderState(true);
      setIsLoading(false);
      // setnewUserSliderState(false);
    } catch (error) {
      console.log("error.message", error.message);
      setError(error.message);
      await resendOTP("+" + phone);
      // let obj_maintenance = document.getElementById("btn_sendotp");
      // obj_maintenance.style.display = "block";
      setIsLoading(false); // Stop the loader
    }
  };

  // OTP verify
  const verifyOTP = async (e) => {
    e.preventDefault();
    setmobilenoSliderState(false);
    if (otp === "" || otp === undefined || otp === null || otp < 6) {
      return setError("Please enter six digit OTP");
    }
    setIsLoading(true); // Start the loader
    setError("");

    try {
      await confirmObj.confirm(otp).then(async (result) => {
        const user = result.user;
        setUser(user);

        // Check if the user is new
        if (result.additionalUserInfo.isNewUser) {
          setUserName(user.displayName);

          // Split the full name by space
          let splitName = userName.split(" ");

          // Extract the first name
          let firstName = splitName[0];

          let imgUrl = "/assets/img/dummy_user.png";

          await user.updateProfile({
            phoneNumber: phone,
            displayName: firstName,
            photoURL: imgUrl,
          });
          let purePhoneNumber = user && user.phoneNumber.slice(-12);
          console.log(" number is ", purePhoneNumber);

          projectFirestore
            .collection("users")
            .doc(purePhoneNumber)
            .set({
              online: true,
              displayName: name,
              fullName: name,
              gender: "",
              phoneNumber: phone,
              email: email,
              city,
              country,
              countryCode,
              address,
              addresses,
              photoURL: imgUrl,
              status: "active",
              isAttendance,
              vehicleNumberPlate,
              vehicleStatus,
              vehicleType,
              isStaff: true,
              drivingLicence,
              accessType: "country",
              accessValue: "India",
              faceRegistration,
              registeredFaceUrl: "",
              uid: user.uid,
              role: "customer",
              roles: ["customer"],
              createdAt: timestamp.fromDate(new Date()),
              lastLoginTimestamp: timestamp.fromDate(new Date()),
            });

          // Add user data to 'enquiries' collection
          const contactData = {
            fullName: name,
            email: email,
            phoneNumber: phone,
            message: formData.message,
            // contactFor: formData.contactFor,
            createdBy: user.phoneNumber,
            createdAt: timestamp.fromDate(new Date()), // Optionally add a created timestamp
          };

          // Use 'set' to add the document with the user.phoneNumber as the document ID
          await projectFirestore.collection("enquiries").doc().set(contactData);

          setSuccessMessage(
            "We appreciate your message and will be in touch with you shortly. Thank you for reaching out to us!"
          );

          setnewUserSliderState(true);
          setotpSliderState(false);
          setIsLoading(false);

          if (dbEmailDoc && dbEmailDoc.status === true) {
            const toList = [formData.email];
            const ccList = dbEmailDoc?.ccList || [];
            const bccList = dbEmailDoc?.bccList || [];
            const emailSubject = dbEmailDoc?.subject || "New General Enquiry";

            const htmlEmailBody = `
      <div style="font-family: Arial, sans-serif; background-color:#f4f6f9; padding:20px;">
        <table width="100%" border="0" cellspacing="0" cellpadding="0" 
          style="max-width:650px; margin:0 auto; background:#ffffff; border-radius:12px; overflow:hidden; box-shadow:0 4px 12px rgba(0,0,0,0.1);">
          
          <!-- Header -->
          <tr>
            <td style="background: ${
              siteColors?.LightScreenTheme.clickColor
            }; padding:25px; text-align:center; color:#fff;">
              <img src=${
                document?.logoUrl
              } alt="Logo" width="160" style="margin-bottom:10px;" />
              <h1 style="margin:0; font-size:22px;">Thank You for Contacting ${
                document?.full_name
              }</h1>
              <p style="margin:5px 0 0; font-size:14px;">We’ve received your enquiry and will get back to you soon.</p>
            </td>
          </tr>

          <!-- User Details -->
          <tr>
            <td style="padding:25px;">
              <h2 style="color:#333; font-size:20px; margin-bottom:15px;">Your Enquiry Details</h2>
              <table width="100%" cellpadding="10" cellspacing="0" style="border-collapse:collapse; border:1px solid #eee; border-radius:8px; overflow:hidden;">
                <tr style="background:#f9f9f9;">
                  <td width="35%" style="font-weight:bold; color:#555;">Name</td>
                  <td style="color:#333;">${name}</td>
                </tr>
                <tr>
                  <td style="font-weight:bold; color:#555;">Email</td>
                  <td style="color:#333;">${email}</td>
                </tr>
                <tr style="background:#f9f9f9;">
                  <td style="font-weight:bold; color:#555;">Phone</td>
                  <td style="color:#333;">${phone}</td>
                </tr>
                <tr style="background:#f9f9f9;">
                  <td style="font-weight:bold; color:#555;">Message</td>
                  <td style="color:#333;">${formData.message || "—"}</td>
                </tr>
              </table>

              <!-- CTA Button -->
              <div style="margin-top:25px; text-align:center;">
                <a href=${document?.siteUrl} target="_blank" 
                  style="display:inline-block; background:${
                    siteColors?.LightScreenTheme.clickColor
                  }; color:#fff; padding:14px 28px; 
                  border-radius:8px; text-decoration:none; font-size:16px; font-weight:bold;">
                  Visit ${document?.full_name}
                </a>
              </div>
            </td>
          </tr>

          <!-- Footer -->
          <tr>
            <td style="background:#f4f4f4; padding:15px; text-align:center; font-size:12px; color:#888;">
              &copy; ${new Date().getFullYear()} ${
              document?.full_name
            }. All rights reserved.
            </td>
          </tr>
        </table>
      </div>`;

            await sendMyEmail(
              toList,
              ccList,
              bccList,
              emailSubject,
              htmlEmailBody
            );
          }
        } else {
          console.log("Existing user signed in with old phone number");
          setIsLoading(true);

          await updateDocument(user.phoneNumber, {
            online: true,
            lastLoginTimestamp: timestamp.fromDate(new Date()),
          });

          // Add user data to 'enquiries' collection
          const contactData = {
            fullName: name,
            email: email,
            phoneNumber: phone,
            message: formData.message,
            // contactFor: formData.contactFor,
            createdBy: user.phoneNumber,
            createdAt: timestamp.fromDate(new Date()), // Optionally add a created timestamp
          };

          // Use 'set' to add the document with the user.phoneNumber as the document ID
          await projectFirestore.collection("enquiries").doc().set(contactData);

          setSuccessMessage(
            "We appreciate your message and will be in touch with you shortly. Thank you for reaching out to us!"
          );

          setotpSliderState(false);
          setnewUserSliderState(false);
          setGenderSelectionSliderState(false);
          setNewUserDetailsSliderState(false);
          setIsLoading(false);

          if (dbEmailDoc && dbEmailDoc.status === true) {
            const toList = [formData.email];
            const ccList = dbEmailDoc?.ccList || [];
            const bccList = dbEmailDoc?.bccList || [];
            const emailSubject = dbEmailDoc?.subject || "New General Enquiry";

            const htmlEmailBody = `
      <div style="font-family: Arial, sans-serif; background-color:#f4f6f9; padding:20px;">
        <table width="100%" border="0" cellspacing="0" cellpadding="0" 
          style="max-width:650px; margin:0 auto; background:#ffffff; border-radius:12px; overflow:hidden; box-shadow:0 4px 12px rgba(0,0,0,0.1);">
          
          <!-- Header -->
          <tr>
            <td style="background: ${
              siteColors?.LightScreenTheme.clickColor
            }; padding:25px; text-align:center; color:#fff;">
              <img src=${
                document?.logoUrl
              } alt="Propdial Logo" width="160" style="margin-bottom:10px;" />
              <h1 style="margin:0; font-size:22px;">Thank You for Contacting ${
                document?.full_name
              }</h1>
              <p style="margin:5px 0 0; font-size:14px;">We’ve received your enquiry and will get back to you soon.</p>
            </td>
          </tr>

          <!-- User Details -->
          <tr>
            <td style="padding:25px;">
              <h2 style="color:#333; font-size:20px; margin-bottom:15px;">Your Enquiry Details</h2>
              <table width="100%" cellpadding="10" cellspacing="0" style="border-collapse:collapse; border:1px solid #eee; border-radius:8px; overflow:hidden;">
                <tr style="background:#f9f9f9;">
                  <td width="35%" style="font-weight:bold; color:#555;">Name</td>
                  <td style="color:#333;">${name}</td>
                </tr>
                <tr>
                  <td style="font-weight:bold; color:#555;">Email</td>
                  <td style="color:#333;">${email}</td>
                </tr>
                <tr style="background:#f9f9f9;">
                  <td style="font-weight:bold; color:#555;">Phone</td>
                  <td style="color:#333;">${phone}</td>
                </tr>
                <tr style="background:#f9f9f9;">
                  <td style="font-weight:bold; color:#555;">Message</td>
                  <td style="color:#333;">${formData.message || "—"}</td>
                </tr>
              </table>

              <!-- CTA Button -->
              <div style="margin-top:25px; text-align:center;">
                <a href=${document?.siteUrl} target="_blank" 
                  style="display:inline-block; background:${
                    siteColors?.LightScreenTheme.clickColor
                  }; color:#fff; padding:14px 28px; 
                  border-radius:8px; text-decoration:none; font-size:16px; font-weight:bold;">
                  Visit ${document?.full_name}
                </a>
              </div>
            </td>
          </tr>

          <!-- Footer -->
          <tr>
            <td style="background:#f4f4f4; padding:15px; text-align:center; font-size:12px; color:#888;">
              &copy; ${new Date().getFullYear()} ${
              document?.full_name
            }. All rights reserved.
            </td>
          </tr>
        </table>
      </div>
    `;

            await sendMyEmail(
              toList,
              ccList,
              bccList,
              emailSubject,
              htmlEmailBody
            );
          }
        }
      });
    } catch (error) {
      console.log("error.message", error.message);
      setError(
        "Given OTP is not valid, please enter the valid OTP sent to your number"
      );
      setIsLoading(false);

      setTimeout(function () {
        setError("");
        setResendOTPFlag(true);
      }, 30000);
    }
  };

  // Toggle OTP visibility
  const toggleOtpVisibility = () => {
    setIsOtpVisible(!isOtpVisible);
  };

  const handlePhoneChange = (value, countryData) => {
    setPhone(value);
    setCountryCode(countryData.countryCode);
    setCountryName(countryData.name);
  };
  // END LOGIN USING CONTACT FORM

  // START CHANGE QR CODE IMAGE
  const handleAddQRClick = () => {
    setIsQrPopupOpen(true);
  };
  // Handle file selection
  const handleQrImageChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setSelectedImage(URL.createObjectURL(e.target.files[0]));
      setImageFile(e.target.files[0]); // Store the file
    }
  };

  const handleConfirmUploadQr = async () => {
    if (!imageFile) return;
    setIsUploading(true); // Start uploading
    setUploadError(null);

    const storageRef = projectStorage.ref();
    const fileRef = storageRef.child(`QRCode/${imageFile.name}`);

    try {
      // Upload image to Firebase Storage
      await fileRef.put(imageFile);
      const downloadURL = await fileRef.getDownloadURL();

      // Update Firestore document with the image URL
      await updateQrCodeDocument("paymentDetails", {
        QRCodeImgUrl: downloadURL,
      });

      setIsQrPopupOpen(false);
    } catch (error) {
      setUploadError("Failed to upload image. Please try again.");
    } finally {
      setIsUploading(false); // Stop uploading
      setSelectedImage(null); // Reset image preview
    }
  };

  const handleCloseQrPopup = () => {
    setIsQrPopupOpen(false);
  };
  // END CHANGE QR CODE IMAGE

  // CHANGE UPI ID START
  const handleEditUpiId = () => {
    setIsEditingUpiId(!isEditingUpiId);
  };

  // Handler to save the updated UPI ID
  const handleSaveUpiId = async () => {
    const editedUpiId = upiId;
    try {
      // Update the UPI ID in Firestore or wherever it needs to be saved
      await updateQrCodeDocument("paymentDetails", { upiId: editedUpiId });
      setIsEditingUpiId(false); // Exit edit mode after saving
      setSnackbarMessage("UPI ID updated successfully");
      setSnackbarOpen(true);
    } catch (error) {
      console.error("Error updating UPI ID:", error);
      setSnackbarMessage("Error updating UPI ID");
      setSnackbarOpen(true);
    }
  };
  // CHANGE UPI ID END

  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phoneNumber: "",
    message: "",
  });

  const [error, setError] = useState(null);
  const [isPending, setIsPending] = useState(false);
  const [successMessage, setSuccessMessage] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  useEffect(() => {
    if (user) {
      const fetchUserData = async () => {
        const userRef = projectFirestore
          .collection("users")
          .doc(user.phoneNumber);
        const doc = await userRef.get();
        if (doc.exists) {
          const userData = doc.data();
          setFormData({
            fullName: userData.fullName || "",
            email: userData.email || "",
            phoneNumber: userData.phoneNumber || "",
            message: "",
          });
        }
      };
      fetchUserData();
    }
  }, [user]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setIsPending(true);

    try {
      const contactconfirm = {
        ...formData,
        createdAt: timestamp.fromDate(new Date()),
      };

      await addDocument(contactconfirm);
      setIsPending(false);
      setSuccessMessage(
        "We appreciate your message and will be in touch with you shortly. Thank you for reaching out to us!"
      );

      // CODE START FOR SEND CONFIRMATION EMAIL
      if (dbEmailDoc && dbEmailDoc.status === true) {
        const toList = [formData.email];
        const ccList = dbEmailDoc?.ccList || [];
        const bccList = dbEmailDoc?.bccList || [];
        const emailSubject = dbEmailDoc?.subject || "New General Enquiry";

        const htmlEmailBody = `
      <div style="font-family: Arial, sans-serif; background-color:#f4f6f9; padding:20px;">
        <table width="100%" border="0" cellspacing="0" cellpadding="0" 
          style="max-width:650px; margin:0 auto; background:#ffffff; border-radius:12px; overflow:hidden; box-shadow:0 4px 12px rgba(0,0,0,0.1);">
          
          <!-- Header -->
          <tr>
            <td style="background: ${
              siteColors?.LightScreenTheme.clickColor
            }; padding:25px; text-align:center; color:#fff;">
              <img src=${
                document?.logoUrl
              } alt="Propdial Logo" width="160" style="margin-bottom:10px;" />
              <h1 style="margin:0; font-size:22px;">Thank You for Contacting ${
                document?.full_name
              }</h1>
              <p style="margin:5px 0 0; font-size:14px;">We’ve received your enquiry and will get back to you soon.</p>
            </td>
          </tr>

          <!-- User Details -->
          <tr>
            <td style="padding:25px;">
              <h2 style="color:#333; font-size:20px; margin-bottom:15px;">Your Enquiry Details</h2>
              <table width="100%" cellpadding="10" cellspacing="0" style="border-collapse:collapse; border:1px solid #eee; border-radius:8px; overflow:hidden;">
                <tr style="background:#f9f9f9;">
                  <td width="35%" style="font-weight:bold; color:#555;">Name</td>
                  <td style="color:#333;">${formData.fullName}</td>
                </tr>
                <tr>
                  <td style="font-weight:bold; color:#555;">Email</td>
                  <td style="color:#333;">${formData.email}</td>
                </tr>
                <tr style="background:#f9f9f9;">
                  <td style="font-weight:bold; color:#555;">Phone</td>
                  <td style="color:#333;">${formData.phoneNumber}</td>
                </tr>
                <tr style="background:#f9f9f9;">
                  <td style="font-weight:bold; color:#555;">Message</td>
                  <td style="color:#333;">${formData.message || "—"}</td>
                </tr>
              </table>

              <!-- CTA Button -->
              <div style="margin-top:25px; text-align:center;">
                <a href=${document?.siteUrl} target="_blank" 
                  style="display:inline-block; background:${
                    siteColors?.LightScreenTheme.clickColor
                  }; color:#fff; padding:14px 28px; 
                  border-radius:8px; text-decoration:none; font-size:16px; font-weight:bold;">
                  Visit ${document?.full_name}
                </a>
              </div>
            </td>
          </tr>

          <!-- Footer -->
          <tr>
            <td style="background:#f4f4f4; padding:15px; text-align:center; font-size:12px; color:#888;">
              &copy; ${new Date().getFullYear()} ${
          document?.full_name
        }. All rights reserved.
            </td>
          </tr>
        </table>
      </div>
    `;

        await sendMyEmail(toList, ccList, bccList, emailSubject, htmlEmailBody);
      }
      // CODE END FOR SEND CONFIRMATION EMAIL

      // Reset fields
      setFormData({
        fullName: "",
        email: "",
        phoneNumber: "",
        message: "",
        // contactFor: "",
      });
      setName("");
      setPhone("");
      setEmail("");
      setIsUploading(false);
    } catch (error) {
      console.error("Error adding document:", error);
      setIsUploading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // START CHANGE CONTACT FORM RIGHT IMAGE
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [imageFile, setImageFile] = useState(null); // To store the file for upload
  const [isUploading, setIsUploading] = useState(false); // New state to track upload status
  const [uploadError, setUploadError] = useState(null); // State for upload error message
  const fileInputRef = useRef(null);
  const handleAddPhotoClick = () => {
    setIsPopupOpen(true);
  };

  // Handle file selection
  const handleImageChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setSelectedImage(URL.createObjectURL(e.target.files[0]));
      setImageFile(e.target.files[0]); // Store the file
    }
  };

  const handleConfirm = async () => {
    if (!imageFile) return;
    setIsUploading(true); // Start uploading
    setUploadError(null);

    const storageRef = projectStorage.ref();
    const fileRef = storageRef.child(`contactUs/formImage/${imageFile.name}`);

    try {
      // Upload image to Firebase Storage
      await fileRef.put(imageFile);
      const downloadURL = await fileRef.getDownloadURL();

      // Update Firestore document with the image URL
      await updateContactUsDocument("contactUs", { formImage: downloadURL });

      setIsPopupOpen(false);
    } catch (error) {
      setUploadError("Failed to upload image. Please try again.");
    } finally {
      setIsUploading(false); // Stop uploading
      setSelectedImage(null); // Reset image preview
    }
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false);
  };
  // END CHANGE CONTACT FORM RIGHT IMAGE

  return (
    <>
      <div className="pg_contact_us">
        {/* START CHANGE CONTACT FORM RIGHT IMAGE */}
        {isPopupOpen && (
          <div className="pg_contact_us_popup-overlay">
            <div className="pg_contact_us_popup-content">
              <button
                className="pg_contact_us_close-btn"
                onClick={handleClosePopup}
              >
                <span class="material-symbols-outlined">close</span>
              </button>
              <div className="pg_contact_us_selected-image-wrapper">
                {/* {selectedImage && (
                  <> */}
                <div
                  className={`pg_contact_us_selected-image-preview ${
                    isUploading ? "dull-background" : ""
                  }`}
                >
                  <img
                    src={
                      selectedImage ||
                      (contactPageData && contactPageData.formImage) ||
                      "/assets/img/contact-us.jfif"
                    }
                    alt="Selected"
                  />
                  {isUploading && (
                    <div className="pg_contact_us_uploading-gif-container">
                      <img
                        src="/assets/img/cloud-upload.gif"
                        alt="Uploading"
                        className="contact-section-uploading-gif"
                      />
                    </div>
                  )}
                </div>
                {/* </>
                )} */}
              </div>

              <div style={{ position: "relative" }}>
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleImageChange}
                  ref={fileInputRef}
                  style={{ display: "none" }}
                />
              </div>
              <div className="d-flex justify-content-between mt-3">
                {!isUploading && (
                  <button
                    className="btn_border"
                    onClick={() => fileInputRef.current.click()}
                  >
                    Replace Image
                  </button>
                )}

                <button
                  className="btn_fill"
                  onClick={handleConfirm}
                  disabled={isUploading}
                >
                  {isUploading ? "Uploading..." : "Confirm"}
                </button>
              </div>
            </div>
          </div>
        )}
        {/* END CHANGE CONTACT FORM RIGHT IMAGE */}
        {/* <AddUsersDoc /> */}
        <section className="loc_em_ph">
          <div className="d-flex align-items-center flex-column pvcy_polcy_head_div">
            <h2
              className="map_heading"
              style={{ textAlign: "center", color: "white" }}
            >
              {document && document.short_name}
            </h2>
          </div>
          <div className="container">
            <div
              className="loc_em_ph_inner"
              style={{
                color: "var(--black-color)",
              }}
            >
              <div className="lep_single">
                <div className="icon_div ">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="30px"
                    viewBox="0 -960 960 960"
                    width="30px"
                    fill="currentColor"
                  >
                    <path d="M240-200h120v-240h240v240h120v-360L480-740 240-560v360Zm-80 80v-480l320-240 320 240v480H520v-240h-80v240H160Zm320-350Z" />
                  </svg>
                </div>
                <h4>Address</h4>
                <h6 className="lep_single_address">
                  {document && document.address}
                </h6>
              </div>

              <div className="lep_single">
                <a
                  href={` mailto:${
                    contactDetails && contactDetails.contactEmail
                  }`}
                  style={{ color: "var(--black-color)" }}
                >
                  <div>
                    <div className="icon_div">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        height="30px"
                        viewBox="0 -960 960 960"
                        width="30px"
                        fill="currentColor"
                      >
                        <path d="m720-160-56-56 63-64H560v-80h167l-63-64 56-56 160 160-160 160ZM160-280q-33 0-56.5-23.5T80-360v-400q0-33 23.5-56.5T160-840h520q33 0 56.5 23.5T760-760v204q-10-2-20-3t-20-1q-10 0-20 .5t-20 2.5v-147L416-520 160-703v343h323q-2 10-2.5 20t-.5 20q0 10 1 20t3 20H160Zm58-480 198 142 204-142H218Zm-58 400v-400 400Z" />
                      </svg>
                    </div>
                    <h4>Email</h4>
                    <h6>{contactDetails && contactDetails.contactEmail}</h6>
                  </div>
                </a>
              </div>

              <div className="lep_single">
                <a
                  href={
                    "tel:" + (contactDetails && contactDetails.contactNumber)
                  }
                  style={{ color: "var(--black-color)" }}
                >
                  <div>
                    <div className="icon_div">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        height="30px"
                        viewBox="0 -960 960 960"
                        width="30px"
                        fill="currentColor"
                      >
                        <path d="M680-200h80v-560h-80v560ZM280-400q17 0 28.5-11.5T320-440q0-17-11.5-28.5T280-480q-17 0-28.5 11.5T240-440q0 17 11.5 28.5T280-400Zm0 120q17 0 28.5-11.5T320-320q0-17-11.5-28.5T280-360q-17 0-28.5 11.5T240-320q0 17 11.5 28.5T280-280Zm-40-240h320v-160H240v160Zm160 120q17 0 28.5-11.5T440-440q0-17-11.5-28.5T400-480q-17 0-28.5 11.5T360-440q0 17 11.5 28.5T400-400Zm0 120q17 0 28.5-11.5T440-320q0-17-11.5-28.5T400-360q-17 0-28.5 11.5T360-320q0 17 11.5 28.5T400-280Zm120-120q17 0 28.5-11.5T560-440q0-17-11.5-28.5T520-480q-17 0-28.5 11.5T480-440q0 17 11.5 28.5T520-400Zm0 120q17 0 28.5-11.5T560-320q0-17-11.5-28.5T520-360q-17 0-28.5 11.5T480-320q0 17 11.5 28.5T520-280Zm80 40v-480H200v480h400Zm80 120q-23 0-40.5-11T611-160H200q-33 0-56.5-23.5T120-240v-480q0-33 23.5-56.5T200-800h411q11-18 28.5-29t40.5-11h80q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120h-80ZM200-240v-480 480Z" />
                      </svg>
                    </div>
                    <h4>Phone</h4>
                    <h6>{contactDetails && contactDetails.contactNumber}</h6>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </section>

        <section className="contact-section">
          <div className="contact-container d-flex justify-content-center align-items-center">
            <div className="contact-image">
              <div className="pg_contact_us_img_and_icon_div">
                <img
                  src={
                    contactPageData?.formImage
                      ? contactPageData.formImage.trim() !== ""
                        ? contactPageData.formImage // Use the database image if available
                        : "/assets/img/contact-us.jfif" // Default image if value is empty
                      : "/assets/img/contact-us.jfif" // Default image if field is not available
                  }
                  alt="Contact"
                  className="pg_contact_us_img_div"
                />

                {user && user.role === "admin" && (
                  <span
                    class="material-symbols-outlined pg_contact_us_img_icon"
                    onClick={handleAddPhotoClick}
                  >
                    add_a_photo
                  </span>
                )}
              </div>
            </div>

            {user ? (
              <div className="contact-form">
                {successMessage ? (
                  <div className="thank-you-message">
                    <h2>Thank You!</h2>
                    <p>{successMessage}</p>
                  </div>
                ) : (
                  <>
                    <h2>Contact Us</h2>
                    <form onSubmit={handleSubmit}>
                      <input
                        type="text"
                        name="fullName"
                        placeholder="Name"
                        value={formData.fullName}
                        onChange={handleInputChange}
                        disabled={!!user}
                      />
                      <input
                        type="email"
                        name="email"
                        placeholder="Email"
                        value={formData.email}
                        onChange={handleInputChange}
                        disabled={!!user}
                      />
                      <input
                        type="text"
                        name="phoneNumber"
                        placeholder="Mobile"
                        value={formData.phoneNumber}
                        onChange={handleInputChange}
                        disabled={!!user}
                      />
                      <textarea
                        name="message"
                        placeholder="Message"
                        value={formData.message}
                        onChange={handleInputChange}
                        required
                      />
                      {/* <select
                        name="contactFor"
                        value={formData.category}
                        onChange={handleInputChange}
                        required
                        className="cat-dropdown-contact-contact-form"
                      >
                        <option value="">Select a category</option>
                        {allCategories &&
                          allCategories.map((category) => (
                            <option key={category.id} value={category.name}>
                              {category.category}
                            </option>
                          ))}
                      </select> */}
                      <div className="d-flex justify-content-center align-items-center">
                        {isPending ? (
                          <PGLoaders />
                        ) : (
                          <button type="submit" className="btn_fill">
                            Submit
                          </button>
                        )}
                      </div>
                    </form>
                  </>
                )}
              </div>
            ) : (
              <div className="col-md-6">
                <div>
                  {mobilenoSliderState && (
                    <>
                      <div className="contact-form">
                        {successMessage ? (
                          <div className="thank-you-message">
                            <h2>Thank You!</h2>
                            <p>{successMessage}</p>
                          </div>
                        ) : (
                          <>
                            <h2>Contact Us</h2>
                            <form onSubmit={handleSubmit}>
                              <input
                                type="text"
                                name="fullName"
                                placeholder="Name"
                                onChange={(e) => setName(e.target.value)}
                                value={name}
                                required
                              />
                              <input
                                type="email"
                                name="email"
                                placeholder="Email"
                                onChange={(e) => setEmail(e.target.value)}
                                value={email}
                                required
                              />
                              <div className="new_form_field with_icon phoneinput">
                                <div>
                                  <PhoneInput
                                    country={"in"}
                                    // onlyCountries={['in', 'us', 'ae']}
                                    value={phone}
                                    onChange={handlePhoneChange}
                                    international
                                    keyboardType="phone-pad"
                                    // countryCallingCodeEditable={false}
                                    countryCodeEditable={true}
                                    // disableCountryCode={true}
                                    placeholder="Country code + mobile number"
                                    inputProps={{
                                      name: "phone",
                                      required: true,
                                      autoFocus: false,
                                    }}
                                    inputStyle={{
                                      width: "100%",
                                      height: "55px",
                                      paddingLeft: "45px",
                                      border: "1px solid #ddd",
                                    }}
                                  ></PhoneInput>
                                </div>
                              </div>

                              <div
                                id="recapcha-container"
                                style={{
                                  marginTop: "-20px",
                                }}
                              ></div>

                              <textarea
                                name="message"
                                placeholder="Message"
                                value={formData.message}
                                onChange={handleInputChange}
                                required
                              />
                              {/* <select
                                name="contactFor"
                                value={formData.category}
                                onChange={handleInputChange}
                                required
                                className="cat-dropdown-contact-contact-form"
                              >
                                <option value="">Select a category</option>
                                {allCategories &&
                                  allCategories.map((category) => (
                                    <option
                                      key={category.id}
                                      value={category.name}
                                    >
                                      {category.category}
                                    </option>
                                  ))}
                              </select> */}
                              {error && (
                                <Alert variant="danger" className="mt-2">
                                  {error}
                                </Alert>
                              )}
                              <div className="d-flex justify-content-center align-items-center">
                                <div className="">
                                  {!isLoading && (
                                    <>
                                      <div className="d-flex justify-content-center flex-column">
                                        <button
                                          className="btn_fill"
                                          style={{ width: "100%" }}
                                          onClick={getOTP}
                                        >
                                          Submit
                                        </button>
                                      </div>
                                    </>
                                  )}
                                </div>
                                {isLoading && (
                                  <div className="text-center">
                                    <h6 className="text_green mb-2">
                                      Sending OTP
                                    </h6>
                                    <PGLoaders />
                                  </div>
                                )}
                              </div>
                            </form>
                          </>
                        )}
                      </div>
                    </>
                  )}

                  {/* start otp section */}
                  {otpSliderState && (
                    <div className="d-flex justify-content-center flex-column align-items-center">
                      <label
                        htmlFor=""
                        className="d-flex align-items-center mb-2"
                      >
                        Enter 6 digit OTP
                        <span
                          onClick={toggleOtpVisibility}
                          style={{
                            cursor: "pointer",
                            marginLeft: "10px",
                            fontSize: "24px",
                            userSelect: "none",
                          }}
                          className="material-symbols-outlined"
                        >
                          {isOtpVisible ? "visibility" : "visibility_off"}
                        </span>
                      </label>

                      <OtpInput
                        value={otp}
                        onChange={setOtp}
                        numInputs={6}
                        renderSeparator={
                          <span style={{ margin: "10px 5px 20px 5px" }}>-</span>
                        }
                        renderInput={(props) => (
                          <input
                            {...props}
                            type={isOtpVisible ? "text" : "password"}
                            onWheel={handleWheel}
                            inputMode="numeric"
                            style={{
                              width: "40px",
                              height: "40px",
                              border: "1px solid gray",
                              textAlign: "center",
                              borderRadius: "5px",
                              margin: "10px 0px 20px 0px",
                            }}
                          />
                        )}
                      />

                      {error && (
                        <Alert variant="danger" className="mt-2">
                          {error}
                        </Alert>
                      )}

                      {!isLoading && (
                        <div className="d-flex justify-content-center flex-column">
                          <button className="btn_fill" onClick={verifyOTP}>
                            Confirm
                          </button>
                        </div>
                      )}
                      {isLoading && (
                        <div className="text-center">
                          <h6 className="text_green mb-2">Sending</h6>
                          <PGLoaders />
                        </div>
                      )}
                    </div>
                  )}
                  {/* end otp section */}
                </div>
              </div>
            )}
          </div>
        </section>

        <section className="form_sec">
          <h2 className="map_top_heading">{document && document.short_name}</h2>
          <iframe
            src={contactDetails && contactDetails.contactmap}
            width="100%"
            height="400"
            style={{ border: 0 }}
            allowFullScreen
          ></iframe>
        </section>

        {/* QR CODE CARD START */}

        {/* START CHANGE QR CODE IMAGE */}
        {isQrPopupOpen && (
          <div className="pg_contact_us_popup-overlay">
            <div className="pg_contact_us_popup-content">
              <button
                className="pg_contact_us_close-btn"
                onClick={handleCloseQrPopup}
              >
                <span class="material-symbols-outlined">close</span>
              </button>
              <div className="pg_contact_us_selected-image-wrapper">
                <div
                  className={`pg_contact_us_selected-image-preview ${
                    isQrUploading ? "dull-background" : ""
                  }`}
                >
                  <img
                    src={
                      selectedImage || (qrCodeData && qrCodeData.QRCodeImgUrl)
                    }
                    alt="Selected"
                  />

                  {isQrUploading && (
                    <div className="pg_contact_us_uploading-gif-container">
                      <img
                        src="/assets/img/cloud-upload.gif"
                        alt="Uploading"
                        className="contact-section-uploading-gif"
                      />
                    </div>
                  )}
                </div>
              </div>

              <div style={{ position: "relative" }}>
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleQrImageChange}
                  ref={fileInputRef}
                  style={{ display: "none" }}
                />
              </div>
              <div className="d-flex justify-content-between mt-3">
                {!isUploading && (
                  <button
                    className="btn_border"
                    onClick={() => fileInputRef.current.click()}
                  >
                    Replace Image
                  </button>
                )}

                <button
                  className="btn_fill"
                  onClick={handleConfirmUploadQr}
                  disabled={isUploading}
                >
                  {isUploading ? "Uploading..." : "Confirm"}
                </button>
              </div>
            </div>
          </div>
        )}
        {/* END CHANGE QR CODE IMAGE */}
        {qrCodeData && qrCodeData.visibilityOnContactUsPage === true && (
          <div className="container services_details_bottom_details_parent">
            <div
              className="justify-content-center align-items-center"
              style={{ paddingBottom: "20px" }}
            >
              <div style={{ borderRadius: "15px" }}>
                <div className="p-2">
                  <div className="d-flex flex-wrap align-items-center justify-content-between">
                    <div className="col-4 col-md-2">
                      <div className="prodct-page-payment-qr-method">
                        <img src="/assets/img/icons/paytm-logo.png" />
                      </div>
                    </div>
                    <div className="col-4 col-md-2">
                      <div className="prodct-page-payment-qr-method">
                        <img src="/assets/img/icons/phonepe-logo.png" />
                      </div>
                    </div>
                    <div className="col-4 col-md-2">
                      <div className="prodct-page-payment-qr-method">
                        <img src="/assets/img/icons/upi-logo.webp" />
                      </div>
                    </div>
                    <div className="col-4 col-md-2">
                      <div className="prodct-page-payment-qr-method">
                        <img src="/assets/img/icons/amazon-pay-logo.webp" />
                      </div>
                    </div>
                    <div className="col-4 col-md-2">
                      <div className="prodct-page-payment-qr-method">
                        <img src="/assets/img/icons/google-pay.webp" />
                      </div>
                    </div>
                    <div className="col-4 col-md-2">
                      <div className="prodct-page-payment-qr-method">
                        <img src="/assets/img/icons/paypal-logo.png" />
                      </div>
                    </div>
                  </div>

                  <hr style={{ marginTop: "0px" }} />

                  <div className="prodct-page-payment-qr-parent row">
                    <div className="prodct-page-payment-qr col-md-5">
                      {user && user.role === "admin" && (
                        <button
                          className="btn_border"
                          onClick={handleAddQRClick}
                        >
                          CHANGE QR CODE
                        </button>
                      )}
                      <img
                        src={
                          qrCodeData?.QRCodeImgUrl
                            ? qrCodeData.QRCodeImgUrl.trim() !== ""
                              ? qrCodeData.QRCodeImgUrl // Use the database image if available
                              : "/assets/img/blur-qr.png" // Default image if value is empty
                            : "/assets/img/blur-qr.png"
                        }
                        alt="qr code img"
                      />
                      <br />
                      {qrCodeData &&
                      (qrCodeData.upiId === null || qrCodeData.upiId === "") ? (
                        <div>
                          {user && user.role === "admin" && (
                            <button
                              onClick={handleEditUpiId}
                              className="btn_fill"
                            >
                              Add UPI
                            </button>
                          )}
                          {isEditingUpiId && (
                            <div>
                              <input
                                type="text"
                                value={upiId}
                                onChange={(e) => setUpiId(e.target.value)}
                                onBlur={handleSaveUpiId} // Save when the input loses focus
                              />
                              <button onClick={handleSaveUpiId}>Save</button>
                            </div>
                          )}
                        </div>
                      ) : (
                        <div>
                          {isEditingUpiId ? (
                            <div>
                              <input
                                type="text"
                                value={upiId}
                                onChange={(e) => setUpiId(e.target.value)}
                              />
                              <svg
                                style={{ cursor: "pointer" }}
                                onClick={handleSaveUpiId}
                                xmlns="http://www.w3.org/2000/svg"
                                height="24px"
                                viewBox="0 -960 960 960"
                                width="24px"
                                fill="var(--click-color)"
                              >
                                <path d="M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z" />
                              </svg>
                            </div>
                          ) : (
                            <>
                              {user && user.role === "admin" ? (
                                <h6
                                  onClick={handleEditUpiId}
                                  style={{
                                    fontWeight: "bold",
                                    letterSpacing: "1px",
                                  }}
                                >
                                  UPI ID : {qrCodeData.upiId}
                                </h6>
                              ) : (
                                <h6
                                  style={{
                                    fontWeight: "bold",
                                    letterSpacing: "1px",
                                  }}
                                >
                                  UPI ID : {qrCodeData.upiId}
                                </h6>
                              )}
                            </>
                          )}
                        </div>
                      )}
                    </div>

                    <div className=" d-flex justify-content-center flex-column col-md-7 mt-4">
                      <MDBCardText className="text-muted">
                        <h3 className="fw-bold mb-3">
                          Accept Payments Easily with QR Scanning!
                        </h3>
                      </MDBCardText>
                      <ul className="list-unstyled">
                        <li className="mb-2">
                          <strong>Quick & Hassle-Free:</strong> Secure QR code
                          payment system for seamless transactions.
                        </li>
                        <li className="mb-2">
                          🔹 <strong>Simple Process:</strong>
                          <ul className="ps-3 mt-1">
                            <li>
                              📌 Scan the QR code using any{" "}
                              <strong>UPI-supported app</strong>.
                            </li>
                            <li>💰 Enter the amount.</li>
                            <li>⚡ Confirm the transaction instantly.</li>
                          </ul>
                        </li>
                        <li className="mb-2">
                          🔹 <strong>Key Benefits:</strong>
                          <ul className="ps-3 mt-1">
                            <li>⚡Instant transactions.</li>
                            <li>🔒 Safe and encrypted payments.</li>
                            <li>📱 Works with all major UPI apps.</li>
                          </ul>
                        </li>
                        {/* <li className="mt-3 fw-bold text-primary">
    🚀 Start using <strong>QR payments today</strong> for a <strong>smarter, cashless, and efficient</strong> payment experience! 
    </li> */}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {/* QR CODE CARD END */}

        <CorporateTwoClients
          category="partners"
          pageName="contact"
          section="partners"
          addMoreVideosButton={false}
          addMoreImagesButton={true}
          addMoreTextContentButton={false}
        />
        {/* <CorporateTwoDownloadApp/> */}
      </div>
    </>
  );
};

export default ContactUs;
